module.exports = __webpack_public_path__ + "dac02b6d4ab03ed6892d4f2157fc9c8e.png";